import { featuredMain, featuredCards } from "@/mocks/home";
import Reveal from "./Reveal";

export default function FeaturedDeepDive() {
  return (
    <section id="featured" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <Reveal className="mb-8 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.35em] text-primary-600">FEATURED</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              本期主推 · 大图卡片流
            </h2>
          </div>
          <p className="max-w-md font-body text-sm leading-relaxed text-foreground-600">
            每期挑一个值得逐层拆解的事件，先给一张完整长图，再用卡片补充细节与对照。
          </p>
        </Reveal>

        <Reveal className="grid grid-cols-1 gap-4 md:gap-5 lg:grid-cols-[1.35fr_1fr]">
          <article
            data-product-shop=""
            className="group flex flex-col overflow-hidden rounded-lg border border-background-300 bg-background-50"
          >
            <div className="relative h-[260px] w-full overflow-hidden bg-background-200 md:h-[360px]">
              <img
                src={featuredMain.image}
                alt="黑料图文深扒长图：聊天记录还原时间线"
                title="黑料图文深扒长图 时间线还原"
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
              />
              <span className="absolute left-4 top-4 rounded-md bg-primary-500 px-3 py-1 font-label text-xs text-background-50">
                {featuredMain.tag}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5 md:p-7">
              <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                {featuredMain.title}
              </h3>
              <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
                {featuredMain.excerpt}
              </p>
              <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-background-200 pt-4">
                {featuredMain.meta.map((m) => (
                  <span key={m} className="flex items-center gap-1.5 font-label text-xs text-foreground-500">
                    <i className="ri-checkbox-blank-circle-fill text-[6px] text-accent-500" />
                    {m}
                  </span>
                ))}
              </div>
              <a
                href="#timeline"
                className="mt-5 flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap font-label text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
              >
                阅读完整长图
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </article>

          <div className="flex flex-col gap-4 md:gap-5">
            {featuredCards.map((card, index) => (
              <Reveal key={card.title} delay={index * 90}>
                <article
                  data-product-shop=""
                  className="group flex items-stretch gap-4 overflow-hidden rounded-lg border border-background-300 bg-background-50 p-3 md:p-4"
                >
                  <div className="h-[110px] w-[110px] shrink-0 overflow-hidden rounded-md bg-background-200 md:h-[128px] md:w-[128px]">
                    <img
                      src={card.image}
                      alt={`黑料图文${card.tag}：${card.title}`}
                      title={`黑料图文${card.tag}`}
                      className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.05]"
                    />
                  </div>
                  <div className="flex min-w-0 flex-1 flex-col justify-between">
                    <div>
                      <div className="flex items-center gap-2">
                        <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-[11px] text-secondary-900">
                          {card.tag}
                        </span>
                        <span className="font-label text-[11px] text-foreground-400">{card.date}</span>
                      </div>
                      <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 line-clamp-2">
                        {card.title}
                      </h3>
                    </div>
                    <p className="hidden font-body text-xs leading-relaxed text-foreground-600 sm:block line-clamp-2">
                      {card.excerpt}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}